<template>
  <div class="blog-detail-wrapper p-0">
    <b-card class="mt-2">
      <b-spinner v-if="isLoading" class="align-middle mb-2" variant="secondary"></b-spinner>
      <b-row>
          <b-col sm="6">
              <validation-provider
              name="CFU"
              rules="required"
              >
                  <b-form-group>
                      <template #label>
                          CFU <span class="text-danger">*</span>
                      </template>
                      <v-select
                      v-model="cfu"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="cfus"
                      @input="onCfuInput"
                      />
                  </b-form-group>
              </validation-provider>
          </b-col>
          <b-col sm="6">
              <validation-provider
              name="Division"
              rules="required"
              >
                  <b-form-group>
                      <template #label>
                          Division <span class="text-danger">*</span>
                      </template>
                      <v-select
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      v-model="division"
                      :options="divisions"
                      label="division"
                      />
                  </b-form-group>
              </validation-provider>
          </b-col>
          <b-col sm="6">
              <validation-provider
              name="CFU Productline"
              rules="required"
              >
                  <b-form-group>
                      <template #label>
                          Unit Segment <span class="text-danger">*</span>
                      </template>
                      <b-form-input
                        id="input-product"
                        placeholder="Unit"
                        v-model="unit"
                        />
                  </b-form-group>
              </validation-provider>
          </b-col>
          <b-col sm="6">
              <b-form-group>
                  <template #label>
                      Timeline <span class="text-danger">*</span>
                  </template>
                  <v-select
                    v-model="quartal"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="['Q1', 'Q2', 'Q3', 'Q4']"
                    class="per-page-selector d-inline-block mr-1"
                    style="width:20%"
                  />
                  -
                  <v-select
                    v-model="year"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="getYears(2021,2999)"
                    class="per-page-selector d-inline-block ml-1 mr-1"
                    style="width:30%"
                  />
              </b-form-group>
          </b-col>
          <b-col sm="12">
              <b-form-group>
                  Market Requirement / Market Research / CI <span class="text-danger">*</span>
                  <snote v-model="ci" ref="snoteSDescription"/>
              </b-form-group>
          </b-col>
          <b-col sm="12">
              <b-form-group>
                  Proposed Product / Solution <span class="text-danger">*</span>
                  <b-form-input
                    v-model="solution"
                    />
              </b-form-group>
          </b-col>
          <b-col sm="12">
              <validation-provider
              name="CFU Productline"
              rules="required"
              >
                  <b-form-group>
                      <template #label>
                          Sales Plan / Year <span class="text-danger">*</span>
                      </template>
                      <snote v-model="salesYear" ref="snoteSDescription"/>
                  </b-form-group>
              </validation-provider>
          </b-col>
          <b-col sm="12">
              <b-form-group>
                  Notes
                  <snote v-model="notes" ref="snoteSDescription"/>
              </b-form-group>
          </b-col>
          <b-col sm="12">
              File Lampiran
              <div id="attachment" class="dropzone dropzone-area mb-3">
                  <div class="dz-message"><feather-icon size="50" icon="DownloadIcon" /></div>
              </div>
          </b-col>
          <b-col sm="12">
            <b-form-group class="d-flex justify-content-end">
                <b-spinner v-if="isLoading" class="align-middle mr-1" variant="secondary"></b-spinner>
                <b-button
                :disabled="isLoading"
                type="submit"
                variant="primary"
                class="mr-1"
                @click="submit()"
                >
                Submit
                </b-button>
            </b-form-group>
          </b-col>
      </b-row>
    </b-card>
    <!--/ blogs -->
  </div>
</template>

<script>
import { BSpinner, BForm, BFormGroup, BFormInput,BAvatar,BLink,BCardText,BCard, BContainer, BRow, BCol, BButton } from 'bootstrap-vue'
import vSelect from 'vue-select'
import snote from './summernote.vue'

export default {
  components: {
    BSpinner,
    BForm, 
    BFormGroup, 
    BFormInput,
    BAvatar,
    BCardText,
    BCard,
    BLink,
    BContainer,
    BRow,
    BCol,
    BButton,
    vSelect,
    dropzoneElements: Object,
    'snote': snote
  },

  data() {
    return {
        isLoading:true,
        cfu:null,
        cfus:[],
        division:null,
        divisions:[],
        unit:null,
        quartal:null,
        year:null,
        ci:'',
        solution:'',
        salesYear:'',
        notes:'',
        attachment:null
    }
  },

  filters: {
    
  },

  mounted() {
    this.initDropzone()
    this.getCFU()
  },

  methods: {
    initDropzone() {
      const options = {
        maxFiles: 10,
        maxFilesize:5,
        autoProcessQueue: true,
        autoQueue: true,
        addRemoveLinks: true,
        acceptedFiles: "application/pdf,.doc,.docx,.xls,.xlsx,.csv,.ppt,.pptx",
        headers: {
          Authorization: `Bearer ${this.$store.getters['oauth/getToken']}`,
        },
      }

      const { drawAtachments, deleteTempAttachemts } = this
      this.dzAttachmentsIns = new window.Dropzone('#attachment', {
        ...options,
        url: `${process.env.VUE_APP_API_HOST}/api/request_prod/uploadFile`,
        init() {
          this.on('success', (file, res) => drawAtachments(res.data))
          this.on('removedfile', file => deleteTempAttachemts(file))
        },
      })
    },

    drawAtachments(path) {
      this.attachment = path
    },

    deleteTempAttachemts(file) {
      const deleteFileTempUrl = '/request_prod/deleteFile'

      this.$http
        .post(deleteFileTempUrl, {
          file: this.attachment,
        })
        .then(() => {
          this.attachment = this.attachment
        })
        .catch(({ data }) => {
          this.$notif('Error', `${data.message}`, 'error')
        })
    },
    validationForm() {
        let errMessage = [];
        if(this.cfu == '' || this.cfu == null || this.cfu == '<br>'){
            errMessage.push('CFU')
        }
        if(this.division == '' || this.division == null || this.division == '<br>'){
            errMessage.push('Division')
        }
        if(this.unit == '' || this.unit == null || this.unit == '<br>'){
            errMessage.push('Unit')
        }
        if(this.quartal == '' || this.quartal == null || this.quartal == '<br>'){
            errMessage.push('Timeline Quartal')
        }
        if(this.year == '' || this.year == null || this.year == '<br>'){
            errMessage.push('Timeline Year')
        }
        if(this.ci == '' || this.ci == null || this.ci == '<br>'){
            errMessage.push('Market Requirement / Market Research / CI')
        }
        if(this.solution == '' || this.solution == null || this.solution == '<br>'){
            errMessage.push('Proposed Product / Solution ')
        }
        if(this.salesYear == '' || this.salesYear == null || this.salesYear == '<br>'){
            errMessage.push('Sales Plan / Year ')
        }

        if(errMessage.length > 0){
            this.$notif('Please fill these field',`${errMessage.join(', ')} fields is required.`,'danger','InfoIcon',5000)
            return false;
        }

        return true
    },
    submit(){
        let valid = this.validationForm()
        if(valid){
            this.sendData() 
        }
    },
    sendData(){
        this.isLoading = true
        this.$http
        .post('/request_prod/store', {
            cfu_id: this.cfu ? this.cfu.id : null,
            division_id: this.division ? this.division.id : null,
            unit: this.unit,
            quartal: this.quartal,
            year: this.year,
            ci: this.ci,
            solution: this.solution,
            sales_year: this.salesYear,
            notes: this.notes,
            attachment: this.attachment
        })
        .then(() => {
            this.$notif('Success', 'Request has been successfully submited.', 'success', 'InfoIcon', 7000)
            this.$router.push({ name: 'home' })
        })
        .catch(({ data }) => {
            this.$notif('Error', `${data.message}`, 'error', 'InfoIcon', 1000)
        })
        .finally(() => {
            this.isLoading = false
        })
    },
    getYears:function(start,stop){
        return new Array(stop-start).fill(start).map((n,i)=>n+i);
    },
    getCFU() {
        this.isLoading = true
        return this.$http.get(`/cfu/take/all`)
        .then(res => {
            this.isLoading = false
            this.cfus = res.data.data.records
        })
    },
    getDivision(id) {
        this.isLoading = true
        this.division = null
        this.divisions = []
        return this.$http.get(`/division/take/all/cfu/${id}`)
        .then(res => {
            this.isLoading = false
            this.divisions = res.data.data.records
            return res
        })
        .catch(err => {
            console.error(err)
        })
    },
    onCfuInput(e) {
        let ids = e.id.toString();
        if (typeof ids == 'string' && e != null) {
            this.onCfuChange(ids)
        }
    },
    onCfuChange(id) {
        this.getDivision(id)
    },
  },
}
</script>

<style scoped>
.dropzone {
    min-height: 250px;
}
/deep/ .dz-message:before {
    display: none;
}

.desc {
    color: #b8c2cc;
    font-size: 0.7rem;
    font-style: italic;
}
/deep/ .dz-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>